import http from './http-common';
import axios from 'axios';
import storage from '../factory/StorageFactory';

const get = () => {  
    
    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank" + " " + storage.getToken(),
          Pragma: 'no-cache'  //IE11
        }
    }
       
    let stateId = storage.getStateId();
  //  return axios.get(`http://localhost:3000/SPersonDtlsSave.json`); 
    return http.get(`/api/v1/SMEDL/getPersonDetailsForm/${stateId}`,headerParams); 
};

const put = (params) => {
  
    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank" + " " + storage.getToken()
        }
    }
      
 
    return http.put(`/api/v1/SMEDL/putPersonalDetailsForm`,params,headerParams);
};

export default {
    get,
    put
};